import movmentLayout from "../pages/module-movment/layout/index";

import layoutPatient from "../pages/module-patient/layout/index-patient";

export default[

    {   path: "/movments",
    component: movmentLayout,
    children: [
    {
        path: "list",
        name: "list",
        component: () =>
        import ("@/pages/module-movment/index"),
    },
    ],
},

{
    path: "/movments",
    component: movmentLayout,
    children: [{
        path: "all",
        name: "all",
        component: () =>
        import ("@/pages/module-movment/all"),
    }, ],
},

{
    path: "/movments",
    component: movmentLayout,
    children: [{
        path: "show/:movment_id",
        name: "show",
        component: () =>
        import ("@/pages/module-movment/show"),
        props: true,
    }, ],
},

{
    path: "/movments",
    component: movmentLayout,
    children: [{
        path: "out/:movment_id",
        name: "out",
        component: () =>
        import ("@/pages/module-movment/out"),
        props: true,
    }, ],
},

{
    path: "/movments",
    component: movmentLayout,
    children: [{
        path: "finish/:movment_id",
        name: "finish",
        component: () =>
        import ("@/pages/module-movment/finish"),
        props: true,
    }, ],
},

{
    path: "/movments",
    component: movmentLayout,
    children: [{
        path: "switcher/:movment_id",
        name: "switcher",
        component: () =>
        import ("@/pages/module-movment/switcher"),
        props: true,
    }, ],
},

{
    path: "/movments",
    component: movmentLayout,
    children: [{
        path: "history/:patients_id",
        name: "history",
        component: () =>
        import ("@/pages/module-movment/history"),
        props: true,
    }, ],
},

{
    path: "/movments",
    component: movmentLayout,
    children: [{
        path: "create",
        name: "create",
        component: () =>
        import ("@/pages/module-movment/create"),
    }, ],

},



{
    path: "/patients",
    component: layoutPatient,
    children: [{
        path: "list",
        name: "list",
        component: () =>
        import ("@/pages/module-patient/patients/index"),
    }, ],
},

{
    path: "/patients",
    component: layoutPatient,
    children: [{
        path: "create",
        name: "create",
        component: () =>
        import ("@/pages/module-patient/patients/create"),
    }, ],
},



]
